import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { DMSv3SettingsDashboardQueryKeys } from "modules/DMSv3/Settings/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerDMS } from "models";

const sortDmsDealers = (dealers: DealerDMS[]) => dealers.toSorted((a, b) => (a.dealer_name ?? "").localeCompare(b.dealer_name ?? ""));

export const useDMSv3DealersListQuery = () => {
  const canListDmsDealers = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.DMSv3SettingDealers);

  return useTypedQuery({
    queryKey: DMSv3SettingsDashboardQueryKeys.dealers,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dms_id: null }, baseUrl)).data.dealer_dms,
    select: sortDmsDealers,
    enabled: canListDmsDealers
  });
};
